// export const appUrl = 'app.bookme.com.pl'
export const appUrl = 'app.bookme.dev.coreo.pl'
// export const appUrl = 'localhost:8080'
